import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { device } from 'GlobalStyles';

const MainIntroduction4 = ({ contents, linkRequired, difImg }: any) => {
  const isMobile = useMediaQuery({ query: device.md });

  return (
    <StyledContainer isMobile={isMobile}>
      <header>
        <div className='left'>
          <h2 className='title'>전략컨설팅 인터뷰 MasterClass [기초편]</h2>
          <p className='description'>
            전략컨설팅 준비 Day 1부터 인터뷰 전까지 도움되는 풀 패키지 온라인 강의{' '}
          </p>
        </div>
        <Link to='/lectures/interview-master-class-basic' className='button'>
          MasterClass [기초편] 시작하기
        </Link>
      </header>
      {/* Lectures */}
      <section className='lectures'>
        <div className='lecture'>
          <div className='video'>
            <iframe
              src='https://player.vimeo.com/video/1026399205?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
              frameBorder='0'
              allow='autoplay; fullscreen; picture-in-picture; clipboard-write'
              title='JK_04_Fit 인터뷰 준비하기 - Fit 인터뷰 접근법'
            ></iframe>
          </div>

          <div className='text'>
            <h5>커리어스텝의 7인 스타 멘토진이 만든 강의</h5>

            <ul>
              <li>최근 합격자부터 인터뷰어 출신 멘토까지 참여</li>
              <li>업계 최초 MBB 출신 컨설턴트 모두 참여</li>
              <li>50인의 전현직 컨설턴트의 검증을 거친 강의</li>
            </ul>
          </div>
        </div>
        <div className='lecture'>
          <div className='video'>
            <iframe
              src='https://player.vimeo.com/video/1026393995?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
              frameBorder='0'
              allow='autoplay; fullscreen; picture-in-picture; clipboard-write'
              title='Han_02_Case 인터뷰 준비하기 - Case 유형 1_Turnaround'
            ></iframe>
          </div>

          <div className='text'>
            <h5>34개의 영상 클립, 7시간 이상의 분량</h5>

            <ul>
              <li>최신 업계 동향 및 인터뷰 트렌드를 반영한 강의</li>
              <li>수강 후 바로 적용가능한 셀프 학습방법 제공</li>
              <li>Edge까지 챙길 수 있는 차별화 전략 제시</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Purchase */}
      <section className='purchase'>
        <h5>전략컨설팅 인터뷰 MasterClass [기초편] 구매하기</h5>

        <div className='info'>
          <h6>MasterClass 기초편 강의 3개월 이용권</h6>

          <div className='prices'>
            <span>정가 55만원</span>
            <strong>
              11<span>만원</span>
            </strong>
            <span>/3개월</span>
          </div>
        </div>

        <div className='button-wrapper'>
          <Link to='/purchase/interview-master-class-basic' className='button primary'>
            구매하기
          </Link>
        </div>
      </section>
    </StyledContainer>
  );
};

export default React.memo(MainIntroduction4);

const StyledContainer = styled.article<{ isMobile: boolean }>`
  max-width: 1440px;
  margin: 0 auto;
  padding: ${({ isMobile }) => (isMobile ? '32px 24px' : '50px 50px 70px 50px')};

  > header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;

    ${({ isMobile }) => (isMobile ? 'flex-direction: column;' : '')}

    .left {
      ${({ isMobile }) => (isMobile ? 'margin-bottom: 24px;' : '')}

      > .title {
        color: #3cac40;
        font-size: ${({ isMobile }) => (isMobile ? 18 : 24)}px;
        margin: 0;
        font-weight: 700;
      }

      > .description {
        font-size: ${({ isMobile }) => (isMobile ? 14 : 20)}px;
        font-weight: 500px;
        margin: 0;
        color: #003159;
      }
    }
  }

  > .lectures {
    display: flex;
    justify-content: center;
    column-gap: 64px;

    ${({ isMobile }) => (isMobile ? 'flex-direction: column; row-gap: 32px' : '')};

    > .lecture {
      width: 100%;
      max-width: 500px;

      > .video {
        position: relative;
        padding-bottom: 56.25%;

        > iframe {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }

      > .text {
        margin-top: ${({ isMobile }) => (isMobile ? '20' : '40')}px;

        > h5 {
          font-size: 20px;
          color: black;
          font-weight: 700;
          margin-bottom: 4px;
        }

        > ul {
          padding-left: 0;
          list-style-position: inside;
          margin-bottom: 0;

          > li {
            font-size: 15px;
            font-weight: 400;
          }
        }
      }
    }
  }

  > .purchase {
    margin-top: 40px;
    padding: ${({ isMobile }) => (isMobile ? '32' : '40')}px;
    border: 1px solid #6abc6d;
    border-radius: 10px;
    display: flex;
    flex-direction: column;

    > h5 {
      font-size: ${({ isMobile }) => (isMobile ? '18' : '24')}px;
      font-weight: 700;
      margin-bottom: ${({ isMobile }) => (isMobile ? '16' : '24')}px;
    }

    > .info {
      background-color: #f9f9f9;
      border-radius: 10px;
      padding: ${({ isMobile }) => (isMobile ? '12px 24px' : '24px 68px')};
      margin-left: auto;
      margin-right: auto;
      display: flex;
      flex-direction: column;
      margin-bottom: 24px;

      > h6 {
        font-size: 18px;
        font-weight: 700;
        color: #003159;
        margin-bottom: 4px;
      }

      > .prices {
        margin: 0 auto;

        > span:first-of-type {
          color: #747474;
          text-decoration: line-through;
          font-size: 18px;
          display: inline-block;
          margin-right: 20px;
        }

        strong {
          color: #3cac40;
          font-size: 48px;

          > span {
            font-size: 18px;
          }
        }

        > span:last-of-type {
          color: #747474;
          font-size: 18px;
          display: inline-block;
        }
      }
    }

    .button-wrapper {
      margin: 0 auto;
    }
  }

  .button {
    all: unset;
    background-color: #003159;
    border-radius: 8px;
    padding: 12px 20px;
    font-weight: 500;
    font-size: 14px;
    color: white;
    transition: all 200ms;
    cursor: pointer;
    width: fit-content;

    &:hover {
      filter: brightness(0.9);
    }

    &:active {
      filter: brightness(0.75);
    }

    &.primary {
      background: #3cac40;
    }
  }
`;
